import { useLayoutEffect } from "react";
import { useCheckBoxGroupContext } from "./check-box-group-context";
import RegisterField, { FieldProps } from "../register-field";
import { CheckBox, CheckBoxProps } from "@/components/inputs";

export default function FormCheckBox({
    name,
    registerOptions = {},
    ...props
}: FieldProps<CheckBoxProps>) {
    const { register, unregister, variant } = useCheckBoxGroupContext();

    useLayoutEffect(() => {
        register(name);
        return () => unregister(name);
    }, []);

    return <RegisterField name={name} disabled={props.disabled} {...registerOptions}>
        {field => (
            <CheckBox
                {...props}

                ref={field.ref}
                checked={field.value}
                disabled={field.disabled}

                onChange={(e, checked) => {
                    field.handleChange(checked);
                    props.onChange && props.onChange(e, checked);
                }}
                onBlur={e => {
                    field.handleBlur();
                    props.onBlur && props.onBlur(e);
                }}
                onKeyDown={e => {
                    props.onKeyDown && props.onKeyDown(e);
                    field.handleKeyDown(e);
                }}

                sx={{ marginLeft: (variant == "collapse" ? "40px" : 0), ...props.sx }}
            />
        )}
    </RegisterField>
}